import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const StoreUIContext = createContext(null);


export function StoreUIProvider({ children }) {
  const [isBasketOpen, setBasketOpen] = useState(false);
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [perksPackageId, setPerksPackageId] = useState(null);
  const [giftPackage, setGiftPackage] = useState(null);
  const giftReturnFocus = useRef(null);

  const openBasket = useCallback(() => setBasketOpen(true), []);
  const closeBasket = useCallback(() => setBasketOpen(false), []);
  const openLogin = useCallback(() => setLoginOpen(true), []);
  const closeLogin = useCallback(() => setLoginOpen(false), []);
  const openPerks = useCallback((packageId) => setPerksPackageId(packageId), []);
  const closePerks = useCallback(() => setPerksPackageId(null), []);
  const openGift = useCallback((pkg, returnFocus = null) => { giftReturnFocus.current = returnFocus; setGiftPackage(pkg); }, []);
  const closeGift = useCallback(() => { setGiftPackage(null); window.setTimeout(() => giftReturnFocus.current?.focus(), 0); }, []);

  const value = useMemo(
    () => ({
      isBasketOpen,
      isLoginOpen,
      perksPackageId,
      giftPackage,
      openBasket,
      closeBasket,
      openLogin,
      closeLogin,
      openPerks,
      closePerks,
      openGift,
      closeGift,
    }),
    [
      isBasketOpen,
      isLoginOpen,
      perksPackageId,
      giftPackage,
      openBasket,
      closeBasket,
      openLogin,
      closeLogin,
      openPerks,
      closePerks,
      openGift,
      closeGift,
    ],
  );

  return <StoreUIContext.Provider value={value}>{children}</StoreUIContext.Provider>;
}

export function useStoreUI() {
  const context = useContext(StoreUIContext);

  if (!context) {
    throw new Error('useStoreUI must be used inside a StoreUIProvider');
  }

  return context;
}
